const home = {
  nav_home: 'Home',
  nav_guides: 'Guides',
  nav_reviews: 'Reviews',
  nav_shipping: 'Shipping',
  nav_qc: 'QC',
  nav_safety: 'Safety',
  nav_faq: 'FAQ',
  nav_about: 'About',
  nav_contact: 'Contact',
  nav_article: 'Article',
  lang_english: 'English',
  lang_french: 'Français',
  lang_danish: 'Dansk',
  lang_german: 'Deutsch',
  hero_title: 'AllChinaBuy Spreadsheet: Your Complete Buying & Shipping Resource',
  hero_subtitle: 'Find, compare and understand AllChinaBuy products with one practical resource.',
  hero_desc: 'The AllChinaBuy Spreadsheet brings together product research resources, seller information, QC guidance, shipping tips, buying tutorials and AllChinaBuy-related information in one easy-to-use hub.',
  cta_primary: 'Explore the AllChinaBuy Spreadsheet',
  cta_secondary: 'Start With the Beginner Guide',
  cta_main_site: 'Visit Main Website',
  cta_buy_now: 'Buy It Now',
  trust_text: 'Independent informational resource • Updated regularly • Built for smarter product research',
  section_what_is_title: 'What Is the AllChinaBuy Spreadsheet?',
  section_what_is_desc: 'The AllChinaBuy Spreadsheet is a centralized resource designed to make product research easier. Explore organized product resources, seller information, QC guidance, shipping references and practical buying tutorials from one place.',
  section_resources_title: 'Everything You Need to Research AllChinaBuy',
  card_spreadsheet_title: 'Spreadsheet',
  card_spreadsheet_desc: 'Explore organized AllChinaBuy product and seller resources.',
  card_shipping_title: 'Shipping',
  card_shipping_desc: 'Understand shipping methods, costs and practical comparison factors.',
  card_qc_title: 'QC',
  card_qc_desc: 'Learn what to check before shipping products.',
  card_sellers_title: 'Sellers',
  card_sellers_desc: 'Learn how to research sellers and evaluate product information.',
  card_reviews_title: 'Reviews',
  card_reviews_desc: 'Read independent AllChinaBuy guides and analysis.',
  card_safety_title: 'Safety',
  card_safety_desc: 'Learn how to identify suspicious links, payment requests and common risks.',
  section_categories_title: 'AllChinaBuy Spreadsheet Categories',
  section_compare_title: 'Compare Before You Buy',
  section_compare_desc: 'Different buying platforms can have different workflows, shipping options and user experiences. Our comparison guides help you understand the differences before making a decision.',
  cta_view_comparisons: 'View All Comparisons',
  section_shipping_title: 'Shipping Shouldn\'t Be a Guess',
  section_shipping_desc: 'Shipping cost depends on factors such as destination, parcel weight, dimensions, shipping method and current carrier pricing.',
  cta_explore_shipping: 'Explore Shipping Guides',
  section_safety_title: 'Built With Safety in Mind',
  section_safety_desc: 'Before clicking a product link, sending a payment or sharing personal information, verify what you\'re using. Our Safety Center explains common risks, suspicious links, account security and payment safety.',
  cta_visit_safety: 'Visit Safety Center',
  section_guides_title: 'Latest AllChinaBuy Guides',
  section_faq_title: 'Frequently Asked Questions',
  faq_q1: 'What is the AllChinaBuy Spreadsheet?',
  faq_a1: 'The AllChinaBuy Spreadsheet is an independent informational resource that organizes product research, seller information, shipping guides, and buying tutorials for users researching AllChinaBuy products.',
  faq_q2: 'Is AllChinaBuy legit?',
  faq_a2: 'AllChinaBuy is a known shopping agent platform. We provide independent guides and resources to help users make informed decisions when using such platforms.',
  faq_q3: 'Is AllChinaBuy safe?',
  faq_a3: 'Safety depends on following best practices: verifying links, using secure payment methods, checking seller reviews, and understanding the platform\'s policies. Our Safety Center has detailed guidance.',
  faq_q4: 'How much does AllChinaBuy shipping cost?',
  faq_a4: 'Shipping costs vary by destination, weight, dimensions, and shipping method. Our shipping guides explain how to estimate and compare costs.',
  faq_q5: 'Where can I find AllChinaBuy coupons?',
  faq_a5: 'Coupons and discount codes may be available through various channels. We update our coupon guide with verified information when available.',
  faq_q6: 'What is the AllChinaBuy warehouse?',
  faq_a6: 'The warehouse is where products are stored before international shipping. Understanding warehouse processes helps you plan your orders better.',
  faq_q7: 'How does AllChinaBuy QC work?',
  faq_a7: 'Quality Control (QC) involves inspecting products before they are shipped to you. Our QC guide explains what to check and how to request inspections.',
  faq_q8: 'How do I use an AllChinaBuy spreadsheet?',
  faq_a8: 'Browse categories, filter by product type, compare sellers, and use the shipping calculator to estimate costs before placing an order.',
  final_cta_title: 'Start Your AllChinaBuy Research',
  final_cta_desc: 'Whether you\'re researching your first product or comparing shipping and seller options, start with the AllChinaBuy Spreadsheet and explore the guides that match your needs.',
  footer_disclaimer: 'This is an independent informational resource and is not the official AllChinaBuy website unless explicitly stated.',
  footer_resources: 'Resources',
  footer_links: 'Links',
  footer_legal: 'Legal',
  breadcrumb_home: 'Home',
  article_read_more: 'Read Full Guide',
  article_published: 'Published',
  article_updated: 'Last Updated',
  article_author: 'Author',
  article_related: 'Related Articles',
  article_sources: 'Sources',
  article_toc: 'Table of Contents',
  dropdown_label: 'Browse Categories',
  category_button_label: 'Shop',
};

export default home;